import { ShieldX } from 'lucide-react';
import { useCurrentUser } from '@/auth/AuthContext';
import { ButtonLink, EmptyState } from '@/components/ui';

/** Shown when a signed-in user opens a URL their role does not include. */
export function AccessDeniedPage({ area }: { area?: string }) {
  const user = useCurrentUser();
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <EmptyState
        icon={<ShieldX size={20} aria-hidden="true" />}
        title="Access denied"
        description={
          <>
            Your role (<span className="font-medium text-ink">{user.role.name}</span>) does not include access to {area ?? 'this page'}. If you need it,
            ask a Super Admin to review your role.
          </>
        }
        action={<ButtonLink to="/categories">Back to Categories</ButtonLink>}
      />
    </div>
  );
}
